import http from "../../http-common";

const get = (data) => http.post("/ErrorHistory/FilterErrorHistory", data);

const create = (data) => http.post("/ErrorHistory/InsertErrorHistory", data);

export default { get, create };
